export const PAL_CATEGORY_1 = 1.2;
export const PAL_CATEGORY_2 = 1.4;
export const PAL_CATEGORY_3 = 1.6;
export const PAL_CATEGORY_4 = 1.8;
export const PAL_CATEGORY_5 = 2.1;
export const PAL_CATEGORY_6 = 2.4;
export const PAL_CATEGORY_7 = 2.8;